import { init } from "../init-streaming";
import { FourOhFourPage } from "../pages/404/404-page";

init(FourOhFourPage);
